import { SxProps } from '@mui/material';

/**
 * Application constants.
 */

export const abortMessage = 'AbortByClick';

/** Fallback file format for file uploads. */
export const defaultAllowedFileFormat = 'PDF';

/** Fallback file format for file uploads. */
export const defaultAllowedDataModelFileFormat = '';

/** German date format string for dayjs. */
export const dayjsFormatDate = 'DD.MM.YYYY';

/**
 * Backend URLs.
 */
export const urlImportDocuments = 'api/import/{replicaId}/documents';
export const urlImportDocumentsUpdate = 'api/import/{replicaId}/documents/update';
export const urlImportPrecheck = 'api/import/{replicaId}/precheck';
export const urlImportUpload = 'api/import/{replicaId}/upload';

export const urlExcelUploadTemplate = 'api/excelupload/template';
export const urlExcelUploadTemplates = 'api/excelupload/templates';
export const urlUserSettings = 'api/settings';
export const urlUserSettingsDigitalSignatures = 'api/settings/navigator/digitalsignatures';
export const urlUserProjects = 'api/user/projects';
export const urlUserProfile = 'api/user/profile';
export const urlUserLogout = 'api/user/logout';
export const urlProjectMetadata = 'api/project/{replicaId}/metadata';

// DocTypeController
export const urlProjectDocTypes = 'api/project/{replicaId}/doctypes';
export const urlImportDocTypes = 'api/project/{replicaId}/doctypes/import-doctypes';
export const urlProjectDocTypeIndices = 'api/project/{replicaId}/doctypes/docindices';
export const urlProjectDocTypeInfo = 'api/project/{replicaId}/doctypes/doctypeinfo';

// DocStatusController
export const urlProjectDocStatus = 'api/project/{replicaId}/docstatus';
export const urlProjectSignatureStatus = 'api/project/{replicaId}/docstatus/signaturestatus';

// FileTypeController
export const urlProjectFileTypes = 'api/project/{replicaId}/filetypes';

// ViewController
export const urlProjectViews = 'api/project/{replicaId}/views';
export const urlProjectViewStructure = 'api/project/{replicaId}/views/viewstructure';
export const urlImportViews = 'api/project/{replicaId}/views/import-views';
export const urlImportViewStructure = 'api/project/{replicaId}/views/import-viewstructure';
export const urlProjectCustomViewSave = 'api/project/{replicaId}/views/custom-view';

// FieldController
export const urlProjectFields = 'api/project/{replicaId}/fields';
export const urlProjectFieldsSchema = 'api/project/{replicaId}/fields/schema';
export const urlProjectFieldsCustom = 'api/project/{replicaId}/fields/custom-fields';
export const urlProjectFieldsSchemaCustom = 'api/project/{replicaId}/fields/custom-schema';

// SessionController
export const urlSessionCheck = 'api/session/check';
export const urlSessionUpdate = 'api/session/update';

// ReportController
export const urlReportsExcelTemplates = 'api/reports/exceltemplates';
export const urlReportsExcelReport = 'api/reports/excelreport';
export const urlReportsRedliningReport = 'api/reports/redliningreport';

// DynamicActionController
export const urlDynamicActionsFormdesigner = 'api/dynamic-actions/formdesigner/run';
export const urlDynamicActionsDocuments = 'api/dynamic-actions/documents/run';
export const urlDynamicActionsReply = 'api/dynamic-actions/reply';

// AreaController
export const urlProjectAreas = 'api/project/{replicaId}/areas';

// ActionController
export const urlProjectActions = 'api/actions/permitted';
export const urlProjectActionGroups = 'api/actions/actiongroups';

// ActivityLogController
export const urlProjectDocumentActivityLogs = 'api/activitylogs';
export const urlProjectDocumentActivityLogsConfig = 'api/activitylogs/config';

// DocumentController
export const urlProjectDocuments = 'api/project/{replicaId}/documents';
export const urlProjectDocumentsFiles = 'api/project/{replicaId}/documents/files';
export const urlProjectDocumentsData = 'api/project/{replicaId}/documents/info';
export const urlProjectDocumentMetadata = 'api/project/{replicaId}/document/{universalId}';
export const urlProjectDocumentData = 'api/project/{replicaId}/document/{universalId}/data';
export const urlProjectDocumentDataSave = 'api/project/{replicaId}/document/{universalId}/save';
export const urlProjectDocumentDataPermissions = 'api/project/{replicaId}/document/permissions';
export const urlProjectDocumentReleaseStatusInfo =
    'api/project/{replicaId}/document/{universalId}/releasestatusinfo';
export const urlImportDocNumberConvention =
    'api/project/{replicaId}/document/{universalId}/docnumberconvention';
export const urlProjectDocumentSummary = 'api/project/{replicaId}/documentsummary';
export const urlProjectDocumentHistory = 'api/project/{replicaId}/documenthistory';
export const urlProjectAdditionalAddDocument = 'api/project/{replicaId}/document/create';
export const urlProjectAdditionalAssign = 'api/project/{replicaId}/document/assign';
export const urlProjectDocumentsDelete = 'api/project/{replicaId}/documents/delete';
export const urlProjectDocumentsAddNote = 'api/project/{replicaId}/documents/addnote';
export const urlProjectDocumentsShareEmail = 'api/project/{replicaId}/documents/distribute/email';
export const urlProjectDocumentsTestmode =
    'api/project/{replicaId}/documents/testmode?state={state}';
export const urlProjectDocumentsPark = 'api/project/{replicaId}/documents/park?state={state}';
export const urlProjectDocumentsStop = 'api/project/{replicaId}/documents/stop?state={state}';
export const urlProjectDocumentAddFiles = 'api/project/{replicaId}/document/{universalId}/files';

// AdditionalDocumentController
export const urlProjectAdditionalDocs = 'api/project/{replicaId}/additionalDocuments';
export const urlProjectAdditionalDocLink = 'api/project/{replicaId}/additionalDocuments/link';
export const urlProjectAdditionalDocFields = 'api/project/{replicaId}/additionalDocuments/fields';
export const urlProjectAdditionalDocSchema =
    'api/project/{replicaId}/additionalDocuments/fieldschema';
export const urlProjectAdditionalDocUnassign =
    'api/project/{replicaId}/additionalDocuments/{universalId}/unassign';

// LogController
export const urlProjectLogOpen = 'api/project/{replicaId}/log/open';
export const urlProjectLogAdd = 'api/project/{replicaId}/log/add';
export const urlProjectLogSupportTicket = 'api/project/{replicaId}/log/supportticket';

export const urlProjectCategorizationStructure = 'api/project/{replicaId}/structure';
export const urlProjectSearchDocuments = 'api/project/{replicaId}/search/documents';
export const urlRegisterDocumentFile = 'api/project/{replicaId}/file/open';
export const urlCheckDocumentFile = 'api/project/{replicaId}/file/check';
export const urlProjectFileDownload = 'api/project/{replicaId}/file/export';
export const urlProjectZipDownload = 'api/project/{replicaId}/file/exportzip';
export const urlProjectFileCompare = 'api/project/{replicaId}/file/compare';
export const urlProjectWorkflowHistory = 'api/project/{replicaId}/workflow/history';
export const urlWorkflowPasswordValidation = 'api/project/{replicaId}/workflow/password';
export const urlWorkflowRelease = 'api/project/{replicaId}/workflow/release';
export const urlWorkflowNext = 'api/project/{replicaId}/workflow/next';
export const urlWorkflowForward = 'api/project/{replicaId}/workflow/forward';
export const urlProjectWorkflowInitial = 'api/project/{replicaId}/workflow/open';
export const urlDocumentAdditionalNoticeTypes = 'api/document/additional/notice/types';
export const urlDocumentAdditionalNoticeCreate = 'api/document/additional/notice/create';
export const urlProjectUserlist = 'api/project/{replicaId}/userlist';
export const urlProjectUserEmailList = 'api/project/{replicaId}/userlist/email';
export const urlProjectDocumentation = 'api/project/documentation';
export const urlProjectDocumentationContact = 'api/project/documentation/contact';
export const urlProjectDocumentationDownload = 'api/project/documentation/download';
export const urlProjectDocumentationOpen = 'api/project/documentation/open';
export const urlStampsAll = 'api/stamps/all';
export const urlStampsImage = 'api/stamps/image';
export const urlStampsSave = 'api/stamps/save';
export const urlStampsDelete = 'api/stamps/delete';
export const urlAdvancedExportConfig = 'api/export/advanced/config';
export const urlAdvancedExportDocuments = 'api/export/advanced/documents';
export const urlEmailTemplates = 'api/template/emailtemplates';
export const urlSupportTemplates = 'api/support/message/templates';
export const urlUserDataForSupportTicketCreation = 'api/support/message/userdata';
export const urlProjectCreateSupportTicket = 'api/support/message/create';
export const urlUploadFile = 'api/upload/file';
export const urlWorkflowTaskReply = 'api/project/{replicaId}/workflow/task/reply';
export const urlSpecialRunReleaseLetter = 'api/special/run/releaseletter';
export const urlCreateErrorLog = 'api/errorlog/create';

// Assembly Controller
export const urlAssemblyPartialModels = 'api/project/assembly/partialmodels';
export const urlSaveAssembly = 'api/project/assembly/save';
export const urlNewIndexPartialModels = 'api/project/assembly/newindex/partialmodels';
export const urlConfirmNewIndexAssembly = 'api/project/assembly/newindex/confirm';

// VDC Controller
export const urlVdcDocumentsUpload = 'api/project/vdc/upload';
export const urlVdcDocumentsRemove = 'api/project/vdc/remove';

/** Reset password URL */
export const urlResetPassword = '//passwordreset.eplass.de';

/** Template string for replacing replicaIds in URLs. */
export const urlParamReplicaId = '{replicaId}';

/** Template string for replacing universalId in URLs. */
export const urlParamUniversalId = '{universalId}';

/** Template string for replacing query-param "state" in URLs. */
export const urlQueryParamState = '{state}';

/** Name of the view that is used for showing document version histories. */
export const viewNameDocNumber = 'documents.docnumber';

/** Styles for making an element flexbox-compatible. */
export const flexBase: SxProps = {
    display: 'flex',
    alignItems: 'center',
};

/** Styles for making an element take up all available size from its parent. */
export const fullSize: SxProps = {
    height: '100%',
    width: '100%',
};

/** Session time out constants. */
export const timeoutInMs = 3_300_000; // Set to 3.300.000 milliseconds. (Equals 55 mins)
export const throttleInMs = 1000;
export const syncTimersInMs = 200;

export const leftSidepanelMinWidth = 320;
export const sidepanelMaxWidth = 700;
export const rightSidepanelMinWidth = 350;

/**
 * This variable 'environment' is globally accessible, but only has a value during DEV and QA mode!
 * And it is created serverside in file "\Views\Home\Index.cshtml" and the value comes from "HomeController.cs".
 */
export const environmentVar: string = window['environment'] || '';

/**
 * This variable is set by the Release Pipeline, therefore it has no value during local development!
 */
export const buildNumber = process.env.REACT_APP_BUILD_NUMBER;

/** Maximum file size for support tickes in bytes - 20 MiB. */
export const supportTicketMaximumFileSize = 20 * 1024 * 1024;
